<template>
  <div class="sub-setting-view">
    暂未开放
  </div>
</template>

<script setup>
</script>

<style scoped>
.sub-setting-view{
  text-align: center;
  padding: 10px;
}
</style>